import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/dashboard/profile/')({
  beforeLoad: () => {
    throw redirect({
      to: '/dashboard/profile/personal-information',
    })
  },
})
